import { FilteringSearchingParams } from '@shared/models/http-request.model';

export class GetDiscounts {
  static readonly type = '[Discount] Get discounts';
}
export class FilteringAndSearchingDiscounts {
  static readonly type = '[Discount] Filtering and searching discounts';
  constructor(public params?: FilteringSearchingParams) {}
}
